// extracted by mini-css-extract-plugin
export default {"filter_box":"EnergyTable_filter_box__FWPtq","empty_box":"EnergyTable_empty_box__j722v","modal_empty_box":"EnergyTable_modal_empty_box__tg9ht"};